module.exports = __webpack_public_path__ + "static/media/pgy.86ac5858.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/superVip/pgy.png
// module id = 2067
// module chunks = 6